<section class="safetyinspectionrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>SFI SAFETY APP</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">          
            <div class="col-lg-12" style="background-color: #f8f9fa;" data-aos="fade-left" data-aos-delay="300">
                <div class="row">
                    <div class="col-lg-6">
                        <br/>
                        <img src="../../assets/images/DMS.jpg" class="img-fluid" data-aos="fade-up" data-aos-delay="100">
                    </div>
                    <div class="col-lg-6">
                        <p></p>
                        <h3 class="theme_color fontSize" data-aos="fade-up" data-aos-delay="50">
                            <strong>Measure your safety performance online, anytime.</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="100">
                            SFI Safety partners with the SFI Safety App to give clients a powerful, centralized way to manage safety information, 
                            monitor performance, and improve accountability across their organization. 
                            The platform provides secure, web-based access to inspection data, reports, scores, trends, corrective actions, and other measurable safety information.
                        </p>
                        <p  class="fontSize" data-aos="fade-up" data-aos-delay="100">
                            The SFI Safety App is accessible from any web browser and is also available on mobile devices 
                            through the Apple App Store and Google Play Store. Whether you are in the office, on a jobsite, or managing multiple projects across
                             different locations, authorized users can access the information they need when they need it.
                        </p>
                        <p  class="fontSize" data-aos="fade-up" data-aos-delay="100">
                            By bringing safety information together in one system, organizations can improve communication between field personnel, supervisors, management,
                             and corporate leadership while creating a more consistent approach to safety performance.
                        </p>
                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="150">
                            <strong>Real-time safety results, 24/7</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="200">
                            Your SFI Safety App portal gives you on-demand access to safety inspection
                             reports and related information across your projects and operations.
                             Instead of waiting for spreadsheets, emails, or monthly summaries, 
                             your team can quickly review inspection findings, monitor open items, and evaluate safety activity as it occurs.
                            
                        </p> 
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="200">
                            This increased visibility allows managers to see where improvements are being made, where recurring issues may exist,
                            and which projects or areas may require additional attention.
                        </p> 
                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="150">
                            <strong>Turn safety data into meaningful information</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="200">
                            Collecting safety information is only valuable if you can use it to improve performance.
                             The SFI Safety App helps 
                            transform individual inspections and observations into measurable data that can support better safety decisions.
                        </p>  
                         <p class="fontSize" data-aos="fade-up" data-aos-delay="200"><strong>Reporting and analytics can help your organization:</strong></p>
                        <div>
                            <ul>
                                <li><strong>•	Identify recurring hazards and trends</strong></li>
                                <li><strong>•	Evaluate safety performance across projects</strong></li>
                                <li><strong>•	Track corrective actions and hazard abatement</strong></li>
                                <li><strong>•	Compare performance over time</strong></li>
                                <li><strong>•	Identify areas requiring additional training</strong></li>
                                <li><strong>•	Recognize positive safety performance</strong></li>
                                <li><strong>•	Improve accountability at the supervisor and project level</strong></li>
                                <li><strong>•	Provide leadership with greater visibility into field operations</strong></li>
                            </ul>
                        </div> 
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="200">
                            Instead of simply documenting what happened during an inspection, your safety data becomes
                             a tool for identifying patterns, measuring improvement, and directing resources where they can have the greatest impact.
                        </p>             

                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="250">
                            <strong>Automatic notifications and better communication</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            Receive automatic email notifications when new inspection reports are published so the appropriate members of
                             your team can review findings quickly and begin addressing concerns.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            Having consistent access to the same safety information helps reduce communication gaps and keeps project teams, management, and leadership aligned. Reports, findings, photographs, and
                             corrective actions are maintained in one centralized location rather than being scattered across emails, paper files, or separate systems.
                        </p>
                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="250">
                            <strong>Track progress and strengthen accountability</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            Effective safety management requires more than identifying hazards—it requires ensuring those 
                            hazards are corrected and learning from what the data shows.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            The SFI Safety App provides greater visibility into corrective actions and ongoing safety performance, helping supervisors
                             and managers take ownership of safety 
                            issues and follow them through to completion. Over time, this information can help organizations measure progress, recognize 
                            improvement, and identify areas where additional support may be needed.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            This creates a stronger connection between what happens in the field and the decisions being made by management.
                        </p>
                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="250">
                            <strong>Full Client Use</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            Through the SFI Safety App, additional paid features are available that allow clients to 
                            actively manage their own safety activities within the same platform.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="200"><strong>Clients can:</strong></p>
                        <div>
                            <ul>
                                <li><strong>•	Conduct and document their own safety inspections</strong></li>
                                <li><strong>•	Record safety observations</strong></li>
                                <li><strong>•	Document toolbox talks and safety meetings</strong></li>
                                <li><strong>•	Complete and manage incident investigations</strong></li>
                            </ul>
                        </div> 
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            These features give your organization the ability to create a more complete picture 
                            of safety performance by combining SFI Safety activities with your own internal safety efforts.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            Rather than maintaining separate systems for inspections, meetings, observations, and incidents, 
                            the SFI Safety App allows your team to keep important safety information together in one centralized location.
                        </p>
                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="250">
                            <strong>Use data to go Beyond Compliance</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            The greatest value of safety data is not simply proving that an inspection occurred. 
                            It is understanding what that information tells you about your organization.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300">
                            By identifying trends, measuring performance, tracking corrective actions, and increasing accountability,
                             the SFI Safety App helps organizations move from reactive safety management to a more proactive approach.
                        </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="300"><strong>
                            That is what going Beyond Compliance is about—using real safety information to prevent injuries, strengthen accountability, improve safety culture, and continuously improve performance.
                        </strong> </p>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="350">
                            <a href="/contact" class="theme_color fontRed"><u><strong>Contact us</strong></u></a> to schedule an online demonstration or learn more about how the SFI Safety App can help 
                            your organization measure performance, improve accountability, and go Beyond Compliance.
                        </p>
                        <!-- <h3 class="fontSize" data-aos="fade-up" data-aos-delay="350">
                            <strong>See an online demonstration</strong>
                        </h3>
                        <p class="fontSize" data-aos="fade-up" data-aos-delay="350">
                            <a href="/contact" class="theme_color fontRed"><u><strong>Contact us</strong></u></a> for an online demonstration or for more information about our exclusive Safety Data Management System.
                        </p>

                        <p class="fontSize" data-aos="fade-up" data-aos-delay="350">
                            Having issues with the DMS site or app? Visit our <a href="/faq" class="theme_color fontRed"><u><strong>FAQ’s</strong></u></a> here
                        </p> -->

                    </div>
                </div>
                <p></p>
                <div class="row">
                    <div class="col-lg-6">
                        <h3 class="fontSize" data-aos="fade-up" data-aos-delay="100">
                            <strong>Now Available! SFI Safety App mobile app on Apple and Android</strong>
                        </h3>
                        <img src="../../assets/images/mobile-tablet.jpg"  class="img-fluid" data-aos="fade-up" data-aos-delay="300"><br/>
                    </div>
                    <div class="col-lg-6">
                        <span class="smallfontsize" data-aos="fade-up" data-aos-delay="100"><strong>Through the app users will soon be able to:</strong></span>

                        <div class="row" style="padding-top: 10px;padding-bottom: 10px;" data-aos="fade-up" data-aos-delay="200">
                            <div class="col-lg-3 col-6 text-center">
                                <a href="https://play.google.com/store/apps/details?id=com.sfi.mobileapp" target="_blank"><i class="fa fa-android" style="font-size: 64px;color: gray;"></i></a>
                            </div>
                            <div class="col-lg-3 col-6 text-center">
                                <a href="https://apps.apple.com/app/sfi-dms-safety-app/id1466584086" target="_blank"><i class="fa fa-apple" style="font-size: 64px;color: gray;"></i></a>
                            </div>
                        </div>


                        <ul class="smallfontsize">
                            <li data-aos="fade-up" data-aos-delay="300"><i class="fa fa-circle facirclesize"></i><span class="smallfontsize">&nbsp;Enter their own safety inspections.</span></li>
                        </ul>
                        <ul class="smallfontsize">
                            <li data-aos="fade-up" data-aos-delay="400"><i class="fa fa-circle facirclesize"></i><span class="smallfontsize">&nbsp;Record regular safety observations.</span></li>
                        </ul>
                        <ul class="smallfontsize">
                            <li data-aos="fade-up" data-aos-delay="500"><i class="fa fa-circle facirclesize"></i><span class="smallfontsize">&nbsp;Document Tool Box Talks.</span></li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>